module.exports = __webpack_public_path__ + "static/img/irole.65acaad.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/kc/irole.png
// module id = D/H5
// module chunks = 7